module.exports = __webpack_public_path__ + "img/1_003.28b80959.jpg";